import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
// import { AppComponent } from '../app.component';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { StompHeaders, StompSubscription } from '@stomp/stompjs';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
  })
export class WebsocketService {
    // webSocketEndPoint: string = 'https://dev.icodetest.com:8080/socket';
    // webSocketEndPoint: string = 'http://localhost:8080/socket';
    webSocketEndPoint: string = environment.backendEndpoint + ":8080/socket";
    topic: string = "/app/getExecutionss";
    stompClient: any;
    errorCallBackTimeOut: any = null;
    private heartbeatInterval: any;
    private stompHeartBeatSubscription: StompSubscription;

    private connectionSubject: Subject<boolean> = new Subject<boolean>();
    // appComponent: AppComponent;
    // appComponent: AppComponent
    constructor(private authenticationService: AuthenticationService){
        // this.appComponent = appComponent;
    }

    public onConnection(): Observable<boolean> {
      return this.connectionSubject.asObservable();
    }

    getHeaders(): {} {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let token = '';
        if (currentUser && currentUser.token) {
            token = currentUser.token;
        }
        const headers: StompHeaders = {
            Authorization: `Bearer ${token}`,
        };
        return headers;
    }

    _connect() {
        console.log("Initialize WebSocket Connection");
        let ws = new SockJS(this.webSocketEndPoint);
        this.stompClient = Stomp.over(ws);
        const _this = this;
        _this.stompClient.connect(
            this.getHeaders(),
            function (frame) {
                console.log(frame);
                clearTimeout(_this.errorCallBackTimeOut);
                _this.stompClient.reconnect_delay = 2000;

                _this.stompHeartBeatSubscription = _this.stompClient.subscribe('/message/heartbeat', (message) => {
                    console.log(message)
                });
                _this.connectionSubject.next(true);
                _this.heartbeatInterval = setInterval(() => {
                    _this.stompClient.send('/app/heartbeat', _this.getHeaders(), '');
                }, 10000);

            },
            (error)=>{
            console.log(error);
            clearInterval(this.heartbeatInterval);
            if (error != undefined && error.headers != undefined && error.headers.message != undefined && error.headers.message.includes("Invalid token")) {
                this.authenticationService.logout();
                location.reload();
            } else {
                this.errorCallBackTimeOut = setTimeout(() => {
                        this._connect();
                    }, 5000);
                }
            }
        );
    };

    _disconnect() {
        if(this.stompHeartBeatSubscription) {
            this.stompHeartBeatSubscription.unsubscribe();
        }
        clearInterval(this.heartbeatInterval);
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
        }
        console.log("Disconnected");
    }

    // on error, schedule a reconnection attempt
    errorCallBack(error) {
        console.log("errorCallBack -> " + error)
        this.errorCallBackTimeOut = setTimeout(() => {
            this._connect();
        }, 5000);
    }

 /**
  * Send message to sever via web socket
  * @param {*} message 
  */
    _send(message) {
        console.log("calling db1 getReportExecutions using endpoint /app/send/getExecutionss");
        this.stompClient.send("/app/send/getExecutionss", this.getHeaders(), JSON.stringify(message));
    }
    _senddb2(message) {
        console.log("calling db2 getReportExecutions using endpoint /app/send/getExecutionssdb2");
        this.stompClient.send("/app/send/getExecutionssdb2", this.getHeaders(), JSON.stringify(message));
    }
    _sendReportId(message) {
        console.log("calling getReportById using endpoint /app/send/getReportById");
        this.stompClient.send("/app/send/getReportById", this.getHeaders(), JSON.stringify(message));
    }
    _sendBrowserIterationId(message) {
        console.log("calling getBrowserIterationById using endpoint /app/send/getBrowserIterationById");
        this.stompClient.send("/app/send/getBrowserIterationById", this.getHeaders(), JSON.stringify(message));
    }
    onMessageReceived(message) {
        // this.stompClient.
        console.log("Message Recieved from Server :: " + message);
        // this.appComponent.handleMessage(JSON.stringify(message.body));
    }
    _sendScheduled(message) {
    console.log("calling scheduled getReportExecutions using endpoint /app/send/getScheduledExecutions");
    this.stompClient.send("/app/send/getScheduledExecutions", this.getHeaders(), JSON.stringify(message));
    }
    _sendScheduledExeUpdate(message) {
        console.log('subscribing to scheduled execution updates');
        this.stompClient.send('/app/send/getScheduledExecutions', this.getHeaders(), JSON.stringify(message));
    }
}



// import { Injectable } from '@angular/core';
// import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
// import { Subject } from 'rxjs';
// import * as SockJS from 'sockjs-client';
// import * as Stomp from 'stompjs';
// import { Client, over } from 'stompjs';
// import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class WebsocketService {
//   private stompClient: Client;

//   connect(url: string, headers: { [key: string]: string }): Observable<any> {
//     const socket = new SockJS(url, null, { transports: ['websocket'] });
//     this.stompClient = over(socket);

//     return new Observable(observer => {
//       this.stompClient.connect(headers, () => {
//         observer.next({ connected: true });

//         // Subscribe to your WebSocket topic
//         this.stompClient.subscribe('/topic/your-topic', (message) => {
//           observer.next(JSON.parse(message.body));
//         });
//       }, (error) => {
//         observer.error(error);
//       });
//     });
//   }

//   disconnect(): void {
//     if (this.stompClient) {
//       this.stompClient.disconnect();
//     }
//   }

//   // private stompClient: any;

//   constructor() {
//     this.initializeWebSocketConnection();
//   }

//   initializeWebSocketConnection() {
//     const socket = new SockJS('ws://localhost:8080/websocket'); // Replace with your WebSocket endpoint
//     this.stompClient = Stomp.over(socket);
//     this.stompClient.connect({}, () => {
//       this.stompClient.subscribe('/topic/message', (message) => {
//         // Handle incoming messages here
//         console.log('Received message:', message.body);
//       });
//     });
//   }

//   sendMessage(message: any) {
//     this.stompClient.send('/app/getExecutionss', {}, message); // Replace with your send message endpoint
//   }


  // private socket: WebSocket;
  // private messageSubject: Subject<any> = new Subject<any>();

  // constructor() {
  //   this.connect();
  //   this.setupPingPong();
  // }

  // private connect(): void {
  //   const socketUrl = 'ws://localhost:8080/websocket/topic/message/websocket';
  //   this.socket = new WebSocket(socketUrl);

  //   this.socket.addEventListener('open', (event) => {
  //     console.log('WebSocket connection opened.');
  //   });

  //   this.socket.addEventListener('message', (event) => {
  //     const message = JSON.parse(event.data);
  //     console.log('Received message:', message);
  //     this.messageSubject.next(message);
  //   });

  //   this.socket.addEventListener('close', (event) => {
  //     console.log('WebSocket connection closed.');
  //     // You can implement reconnection logic here if needed
  //   });

  //   this.socket.addEventListener('error', (event) => {
  //     console.error('WebSocket error:', event);
  //   });
  // }

  // private setupPingPong(): void {
  //   // Implement your ping-pong logic here
  // }

  // public sendMessage(message: any): void {
  //   if (this.socket.readyState === WebSocket.OPEN) {
  //     this.socket.send(message);
  //   } else {
  //     console.error('WebSocket is not open. Unable to send message.');
  //   }
  // }

  // public onMessage(): Subject<any> {
  //   return this.messageSubject;
  // }



  // private socket$: WebSocketSubject<any>;

  // constructor() {
  //   this.socket$ = webSocket('ws://localhost:8080/websocket');
  //   this.setupPingPong();

  //   this.socket$.subscribe(
  //     (message) => console.log('Received message:', message),
  //     (error) => console.error('WebSocket error:', error),
  //     () => console.log('WebSocket connection closed.')
  //   );
  // }

  // private setupPingPong(): void {
  //   setInterval(() => {
  //     this.socket$.next({ type: 'ping' });
  //   }, 30000); // Send ping every 30 seconds
  // }

  // public onMessage(): any {
  //   return this.socket$.asObservable();
  // }

  // public sendMessage(message: any): void {
  //   // Send a message to the WebSocket server
  //   this.socket$.next(message);
  // }

  // public closeConnection(): void {
  //   this.socket$.complete();
  // }

// }